import { useCallback, useEffect, useRef, useState } from 'react';
import { SeasonLink as Link, SeasonNavLink as NavLink } from '../../components/Seasons/SeasonLink';
import { auctionGet } from '../../api/auction';
import styles from './auction.module.css';

export const CATEGORIES = ['Одежда', 'Стикеры и мелочи', 'Встречи и опыт', 'Аксессуары'];
export const STATUS = { draft: 'Черновик', active: 'Идут торги', completed: 'Завершён', cancelled: 'Отменён' };
export const number = (n) => Number(n || 0).toLocaleString('ru-RU');
export const date = (v) => v ? new Date(v).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', dateStyle: 'medium', timeStyle: 'short' }) + ' МСК' : 'Не задано';
export function remaining(endsAt, now) {
  if (!endsAt) return 'Срок не задан';
  const seconds = Math.max(0, Math.ceil((new Date(endsAt).getTime() - now) / 1000));
  if (!seconds) return 'Торги окончены';
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor(seconds / 3600) % 24;
  const minutes = Math.floor(seconds / 60) % 60;
  return `${days ? `${days} д ` : ''}${String(hours).padStart(2,'0')}:${String(minutes).padStart(2,'0')}:${String(seconds % 60).padStart(2,'0')}`;
}
export const deltaFor = (amount, ownBid) => Math.max(0, Number(amount) - Number(ownBid || 0));

export function useAuctionData(path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [, setTick] = useState(0);
  const clock = useRef({ utc: Date.now(), local: performance.now() });
  const sequence = useRef(0);
  const invalidate = useCallback(() => { sequence.current++; }, []);
  const [received, setReceived] = useState(0);
  const refresh = useCallback(async () => {
    const current = ++sequence.current;
    try {
      const response = await auctionGet(path);
      if (current !== sequence.current) return;
      if (response.server_time) clock.current = { utc: new Date(response.server_time).getTime(), local: performance.now() };
      setData(response); setReceived(performance.now()); setError('');
      return response;
    } catch (e) { if (current === sequence.current) setError(e.message); }
  }, [path]);
  useEffect(() => {
    setData(null); refresh();
    const timer = setInterval(refresh, 5000);
    return () => { clearInterval(timer); invalidate(); };
  }, [refresh, invalidate]);
  useEffect(() => { const timer = setInterval(() => setTick((v) => v + 1), 1000); return () => clearInterval(timer); }, []);
  return { data, error, refresh, now: clock.current.utc + performance.now() - clock.current.local,
    stale: !received || performance.now() - received > 15000 };
}

export function WalletTabs() {
  return <nav className={styles.walletTabs} aria-label="Разделы кошелька">
    <NavLink end to="/transactions" className={({isActive}) => isActive ? styles.selected : ''}>Кошелёк и история</NavLink>
    <NavLink end to="/transactions/auction" className={({isActive}) => isActive ? styles.selected : ''}>Аукцион мерча</NavLink>
    <NavLink to="/transactions/auction/mine" className={({isActive}) => isActive ? styles.selected : ''}>Мои лоты</NavLink>
  </nav>;
}

export function Badge({ status }) { return <span className={`${styles.badge} ${styles[status]}`}>{STATUS[status]}</span>; }
export function LotImage({ lot, index = 0, className }) { return lot.images?.[index] ? <img className={className} src={lot.images[index]} alt={lot.title} loading="lazy" /> : <div className={styles.noImage}>Фото появится здесь</div>; }
export function AuctionTitle({ title, balance }) { return <div className={styles.heading}><h1>{title}</h1>{balance !== undefined && <Link className={styles.balancePill} to="/transactions">{number(balance)} <span>юфунтов в кошельке ↗</span></Link>}</div>; }
export function Dialog({ title, children, onClose }) {
  const ref = useRef();
  useEffect(() => { const element = ref.current; element.showModal(); return () => element.close(); }, []);
  return <dialog ref={ref} className={styles.dialog} onCancel={(e) => { e.preventDefault(); onClose(); }} aria-labelledby="auction-dialog-title">
    <button type="button" className={styles.close} aria-label="Закрыть" onClick={onClose}>×</button>
    <h2 id="auction-dialog-title">{title}</h2>{children}
  </dialog>;
}
